/**
 * One-shot signal that a fresh interactive login (password / OTP / biometric / 2FA) just succeeded
 * on a path that mounts the LoggedIn page, consumed once by the remember-me mint there.
 *
 * Marked at the post-login route decisions, and only when postLoginRoute is LOGGED_IN — a mid-flow
 * re-login (session expiry, recoverable decline) routes straight back into the flow and must not
 * leave a signal a later LoggedIn mount could mint for. The SIGN_UP / ADD_MOBILE profile-completion
 * detours converge on the same postLoginRoute afterwards, so their marks are consumed when LoggedIn
 * eventually mounts.
 *
 * Deliberately plain module state rather than redux: the auth slice is persisted to
 * sessionStorage, so any redux flag needs arming/disarming/consuming cases for every path that
 * could leave it stale (failed logins, abandoned 2FA, password reset, reloads, logout). Module
 * state can't be resurrected by persistence — a reload simply drops the signal and the mint
 * defers to the next login — and it is only ever set at explicit success call sites, so there are
 * no false positives to repair. Never touched during SSR (set in user-event handlers, consumed in
 * a client effect).
 */
let marked = false

export const markInteractiveLogin = (): void => {
  marked = true
}

/** Returns whether a fresh interactive login is pending a mint decision, and clears the signal. */
export const consumeInteractiveLoginSignal = (): boolean => {
  const wasMarked = marked
  marked = false
  return wasMarked
}
